var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleToLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99305 12C6.99305 14.761 9.23905 17.007 12.0001 17.007C14.7611 17.007 17.0071 14.761 17.0071 12C17.0071 9.23901 14.7611 6.993 12.0001 6.993C9.23905 6.993 6.99305 9.23901 6.99305 12ZM12.0001 8.993C13.6581 8.993 15.0071 10.342 15.0071 12C15.0071 13.658 13.6581 15.007 12.0001 15.007C10.3421 15.007 8.99305 13.658 8.99305 12C8.99305 10.342 10.3421 8.993 12.0001 8.993ZM10.9981 19H12.9981V22H10.9981V19ZM10.9981 2H12.9981V5H10.9981V2ZM1.99805 11H4.99805V13H1.99805V11ZM18.9981 11H21.9981V13H18.9981V11ZM4.21905 18.363L6.33905 16.241L7.75405 17.655L5.63405 19.777L4.21905 18.363ZM16.2401 6.344L18.3621 4.222L19.7761 5.636L17.6541 7.758L16.2401 6.344ZM6.34205 7.759L4.22005 5.637L5.63505 4.223L7.75505 6.345L6.34205 7.759ZM19.7761 18.364L18.3621 19.778L16.2401 17.656L17.6541 16.242L19.7761 18.364Z",
    fill: "#3E85F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleToLight);
export default __webpack_public_path__ + "static/media/toggleToLight.34597d4bee14e23d0e51399e4231671b.svg";
export { ForwardRef as ReactComponent };